import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlackHole: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="black-hole, galaxy, delete-forever, hide"><path d="M20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C9.47262 20.75 7.19551 19.6785 5.5982 17.9649L3.25 20V12C3.25 7.16751 7.16751 3.25 12 3.25C14.4216 3.25 16.6135 4.23373 18.1977 5.82337L20.75 3.84877V12Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="3.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBlackHole;
